import { getfile } from "@/entities/message";

const DB_NAME = "MediaCacheDB";
const STORE_NAME = "blobs";
const VERSION = 1;

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, VERSION);

    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);

    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
  });
}

async function getBlobFromDB(key: string): Promise<Blob | null> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);
    const request = store.get(key);

    request.onsuccess = () => resolve(request.result || null);
    request.onerror = () => reject(request.error);
  });
}

async function saveBlobToDB(key: string, blob: Blob): Promise<void> {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readwrite");
    const store = tx.objectStore(STORE_NAME);
    const request = store.put(blob, key);

    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
}

export interface CachedBlob {
  blob: Blob;
  url: string;
}
const sessionBlobCache = new Map<string, CachedBlob>();

export const getCachedBlob = async (key: string): Promise<CachedBlob> => {
  if (sessionBlobCache.has(key)) {
    return sessionBlobCache.get(key)!;
  }

  let blob = await getBlobFromDB(key);
  if (!blob) {
    blob = await getfile(key);
    await saveBlobToDB(key, blob);
  }

  const url = URL.createObjectURL(blob);
  const cached = { blob, url };
  sessionBlobCache.set(key, cached);
  return cached;
};

// export const clearSessionBlobCache = () => {
//   sessionBlobUrlCache.forEach(URL.revokeObjectURL);
//   sessionBlobUrlCache.clear();
// };

export const clearPersistentBlobCache = async () => {
  // clearSessionBlobCache();
  const db = await openDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  const store = tx.objectStore(STORE_NAME);
  store.clear();
};